import $ from 'jquery'
export const TEST = {
    audio: /(mp3|ogg|mpeg)/,
    image: /(png|jpg|jpeg|gif)/,
    video:/(ogg|mp4|webm)/,
    file: /(txt|pdf|ppt|doc|xls)/,
}

export const EN_num = () => {
    let obj = {};
    for(let i = 0; i < 26; i++){
        obj[i] = String.fromCharCode(i + 65)
    }
    return obj
};

export function onmousedownType(type,callback){
    document.oncontextmenu = function(e) {
        return false;
    }
    document.onmousedown = function(e) {
        if(e.button === type){
            callback();
        }
        // switch(e.button) {
        //     case 0:
        //         console.log("鼠标左键")
        //         callback;
        //     break;
        //     case 1:
        //         console.log("鼠标中间");
        //         callback;
        //     break;
        //     case 2:
        //         console.log("鼠标右键");
        //         callback;
        //         break;
        //     default:
        //         break;
        // }
    }
}


export const w_c = {
    w:$(window).width(),
    h:$(window).height(),
    t(el){
        return $(el).position().top
    },
    l(el){
        return $(el).position().left
    },
    s_t:$(window).scrollTop(),
    s_l:$(window).scrollLeft(),
    s_t_to(t){
        $('html, body').animate({scrollTop:t + "px"}, 500);
    },
    s_l_to(l){
        $('html, body').animate({scrollLeft:l + "px"}, 500);
    },
}

/**
 * 自定义右键功能列表 回调自定义方法
 * [oncontextMenu description]
 * @param  {[type]} menu_lists [description]
 * @return {[type]}            [description]
 */
export function oncontextMenu(menu_lists){
    document.oncontextmenu = function(e) {
        return false;
    }
    document.onmousedown = function(e) {
        if(e.button === 2){
            $('input').blur();
            $("#menu").remove();
            var x = e.clientX;
            var list_count = 5;
            var y = e.clientY;
            if(e.clientX + 252 > $(window).width()){
                x = $(window).width() - 252
            }
            if(e.clientY + 30 * list_count + 10 > $(window).height()){
                y = $(window).height() - 30 * list_count - 12
            }
            var html = ``;
            menu_lists.map(list => {
                html += `<div class="menu" style="width: 250px;height: 30px;line-height: 30px;padding: 0 10px;cursor: pointer;" key="${list.key}">${list.title}</div>`;
            })
            $("body").append(`<div id="menu" style="padding:5px 0;font-size:13px;color:#888da8;border-radius:4px;background:#fff;left:${x}px;top:${y}px;width:auto;height:auto;overflow:hidden;position:absolute;box-shadow: 0 2px 2px #888,2px 0 2px #ccc;">${html}</div>`);
            $(".menu").hover(function(){$(this).css({backgroundColor:'#f1f1f1'})}, function(){$(this).css({backgroundColor:'#fff'})})
            $(".menu").click(function(e){
                e.stopPropagation;
                menu_lists.map((list) => {
                    if(list.key === +$(this).attr('key')){
                        list.callback();
                    }
                })
            })
            $(window).click(function(e){
                $("#menu").remove();
            })
        }
    }
}

export function getCss3TransfromValue(el){
    var now = $(".main-content .el-scrollbar__thumb").css("transform").replace(/[^0-9\-,]/g,'').split(',');

    function getmatrix(a,b,c,d){
        var aa=Math.round(180*Math.asin(a)/ Math.PI);
        var bb=Math.round(180*Math.acos(b)/ Math.PI);
        var cc=Math.round(180*Math.asin(c)/ Math.PI);
        var dd=Math.round(180*Math.acos(d)/ Math.PI);
        var deg=0;
        if(aa==bb||-aa==bb){
            deg=dd;
        }else if(-aa+bb==180){
            deg=180+cc;
        }else if(aa+bb==180){
            deg=360-cc||360-dd;
        }
        return deg>=360?0:deg;
    }
    var a = now[0];
    var b = now[1];
    var c = now[2];
    var d = now[3];
    return {
        matrix:now,
        matrix3d:'',
        rotate:getmatrix(a,b,c,d),
        rotate3d:'',
        rotateX:'',
        rotateY:'',
        rotateZ:'',
        translate:'',
        translate3d:'',
        translateY:'',
        translateX:'',
        translateZ:'',
        scale:'',
        scale3d:'',
        scaleX:'',
        scaleY:'',
        scaleZ:'',
        skew:'',
        skewX:'',
        skewY:'',
        perspective:'',
    }
}


/*css*/
/*

alignContent: ""
alignItems: ""
alignSelf: ""
alignmentBaseline: ""
all: ""
animation: ""
animationDelay: ""
animationDirection: ""
animationDuration: ""
animationFillMode: ""
animationIterationCount: ""
animationName: ""
animationPlayState: ""
animationTimingFunction: ""
backfaceVisibility: ""
background: ""
backgroundAttachment: ""
backgroundBlendMode: ""
backgroundClip: ""
backgroundColor: ""
backgroundImage: ""
backgroundOrigin: ""
backgroundPosition: ""
backgroundPositionX: ""
backgroundPositionY: ""
backgroundRepeat: ""
backgroundRepeatX: ""
backgroundRepeatY: ""
backgroundSize: ""
baselineShift: ""
blockSize: ""
border: ""
borderBlockEnd: ""
borderBlockEndColor: ""
borderBlockEndStyle: ""
borderBlockEndWidth: ""
borderBlockStart: ""
borderBlockStartColor: ""
borderBlockStartStyle: ""
borderBlockStartWidth: ""
borderBottom: ""
borderBottomColor: ""
borderBottomLeftRadius: ""
borderBottomRightRadius: ""
borderBottomStyle: ""
borderBottomWidth: ""
borderCollapse: ""
borderColor: ""
borderImage: ""
borderImageOutset: ""
borderImageRepeat: ""
borderImageSlice: ""
borderImageSource: ""
borderImageWidth: ""
borderInlineEnd: ""
borderInlineEndColor: ""
borderInlineEndStyle: ""
borderInlineEndWidth: ""
borderInlineStart: ""
borderInlineStartColor: ""
borderInlineStartStyle: ""
borderInlineStartWidth: ""
borderLeft: ""
borderLeftColor: ""
borderLeftStyle: ""
borderLeftWidth: ""
borderRadius: ""
borderRight: ""
borderRightColor: ""
borderRightStyle: ""
borderRightWidth: ""
borderSpacing: ""
borderStyle: ""
borderTop: ""
borderTopColor: ""
borderTopLeftRadius: ""
borderTopRightRadius: ""
borderTopStyle: ""
borderTopWidth: ""
borderWidth: ""
bottom: ""
boxShadow: ""
boxSizing: ""
breakAfter: ""
breakBefore: ""
breakInside: ""
bufferedRendering: ""
captionSide: ""
caretColor: ""
clear: ""
clip: ""
clipPath: ""
clipRule: ""
color: ""
colorInterpolation: ""
colorInterpolationFilters: ""
colorRendering: ""
columnCount: ""
columnFill: ""
columnGap: ""
columnRule: ""
columnRuleColor: ""
columnRuleStyle: ""
columnRuleWidth: ""
columnSpan: ""
columnWidth: ""
columns: ""
contain: ""
content: ""
counterIncrement: ""
counterReset: ""
cssFloat: ""
cssText: "height: 43.125%; transform: translateY(22.2965%);"
cursor: ""
cx: ""
cy: ""
d: ""
direction: ""
display: ""
dominantBaseline: ""
emptyCells: ""
fill: ""
fillOpacity: ""
fillRule: ""
filter: ""
flex: ""
flexBasis: ""
flexDirection: ""
flexFlow: ""
flexGrow: ""
flexShrink: ""
flexWrap: ""
float: ""
floodColor: ""
floodOpacity: ""
font: ""
fontDisplay: ""
fontFamily: ""
fontFeatureSettings: ""
fontKerning: ""
fontSize: ""
fontStretch: ""
fontStyle: ""
fontVariant: ""
fontVariantCaps: ""
fontVariantEastAsian: ""
fontVariantLigatures: ""
fontVariantNumeric: ""
fontVariationSettings: ""
fontWeight: ""
gap: ""
grid: ""
gridArea: ""
gridAutoColumns: ""
gridAutoFlow: ""
gridAutoRows: ""
gridColumn: ""
gridColumnEnd: ""
gridColumnGap: ""
gridColumnStart: ""
gridGap: ""
gridRow: ""
gridRowEnd: ""
gridRowGap: ""
gridRowStart: ""
gridTemplate: ""
gridTemplateAreas: ""
gridTemplateColumns: ""
gridTemplateRows: ""
height: "43.125%"
hyphens: ""
imageRendering: ""
inlineSize: ""
isolation: ""
justifyContent: ""
justifyItems: ""
justifySelf: ""
left: ""
length: 2
letterSpacing: ""
lightingColor: ""
lineBreak: ""
lineHeight: ""
listStyle: ""
listStyleImage: ""
listStylePosition: ""
listStyleType: ""
margin: ""
marginBlockEnd: ""
marginBlockStart: ""
marginBottom: ""
marginInlineEnd: ""
marginInlineStart: ""
marginLeft: ""
marginRight: ""
marginTop: ""
marker: ""
markerEnd: ""
markerMid: ""
markerStart: ""
mask: ""
maskType: ""
maxBlockSize: ""
maxHeight: ""
maxInlineSize: ""
maxWidth: ""
maxZoom: ""
minBlockSize: ""
minHeight: ""
minInlineSize: ""
minWidth: ""
minZoom: ""
mixBlendMode: ""
objectFit: ""
objectPosition: ""
offset: ""
offsetDistance: ""
offsetPath: ""
offsetRotate: ""
opacity: ""
order: ""
orientation: ""
orphans: ""
outline: ""
outlineColor: ""
outlineOffset: ""
outlineStyle: ""
outlineWidth: ""
overflow: ""
overflowAnchor: ""
overflowWrap: ""
overflowX: ""
overflowY: ""
overscrollBehavior: ""
overscrollBehaviorX: ""
overscrollBehaviorY: ""
padding: ""
paddingBlockEnd: ""
paddingBlockStart: ""
paddingBottom: ""
paddingInlineEnd: ""
paddingInlineStart: ""
paddingLeft: ""
paddingRight: ""
paddingTop: ""
page: ""
pageBreakAfter: ""
pageBreakBefore: ""
pageBreakInside: ""
paintOrder: ""
parentRule: null
perspective: ""
perspectiveOrigin: ""
placeContent: ""
placeItems: ""
placeSelf: ""
pointerEvents: ""
position: ""
quotes: ""
r: ""
resize: ""
right: ""
rowGap: ""
rx: ""
ry: ""
scrollBehavior: ""
scrollMargin: ""
scrollMarginBlock: ""
scrollMarginBlockEnd: ""
scrollMarginBlockStart: ""
scrollMarginBottom: ""
scrollMarginInline: ""
scrollMarginInlineEnd: ""
scrollMarginInlineStart: ""
scrollMarginLeft: ""
scrollMarginRight: ""
scrollMarginTop: ""
scrollPadding: ""
scrollPaddingBlock: ""
scrollPaddingBlockEnd: ""
scrollPaddingBlockStart: ""
scrollPaddingBottom: ""
scrollPaddingInline: ""
scrollPaddingInlineEnd: ""
scrollPaddingInlineStart: ""
scrollPaddingLeft: ""
scrollPaddingRight: ""
scrollPaddingTop: ""
scrollSnapAlign: ""
scrollSnapStop: ""
scrollSnapType: ""
shapeImageThreshold: ""
shapeMargin: ""
shapeOutside: ""
shapeRendering: ""
size: ""
speak: ""
src: ""
stopColor: ""
stopOpacity: ""
stroke: ""
strokeDasharray: ""
strokeDashoffset: ""
strokeLinecap: ""
strokeLinejoin: ""
strokeMiterlimit: ""
strokeOpacity: ""
strokeWidth: ""
tabSize: ""
tableLayout: ""
textAlign: ""
textAlignLast: ""
textAnchor: ""
textCombineUpright: ""
textDecoration: ""
textDecorationColor: ""
textDecorationLine: ""
textDecorationSkipInk: ""
textDecorationStyle: ""
textIndent: ""
textOrientation: ""
textOverflow: ""
textRendering: ""
textShadow: ""
textSizeAdjust: ""
textTransform: ""
textUnderlinePosition: ""
top: ""
touchAction: ""
transform: "translateY(22.2965%)"
transformBox: ""
transformOrigin: ""
transformStyle: ""
transition: ""
transitionDelay: ""
transitionDuration: ""
transitionProperty: ""
transitionTimingFunction: ""
undefined: "translateY(22.296544035674472%)"
unicodeBidi: ""
unicodeRange: ""
userSelect: ""
userZoom: ""
vectorEffect: ""
verticalAlign: ""
visibility: ""
webkitAlignContent: ""
webkitAlignItems: ""
webkitAlignSelf: ""
webkitAnimation: ""
webkitAnimationDelay: ""
webkitAnimationDirection: ""
webkitAnimationDuration: ""
webkitAnimationFillMode: ""
webkitAnimationIterationCount: ""
webkitAnimationName: ""
webkitAnimationPlayState: ""
webkitAnimationTimingFunction: ""
webkitAppRegion: ""
webkitAppearance: ""
webkitBackfaceVisibility: ""
webkitBackgroundClip: ""
webkitBackgroundOrigin: ""
webkitBackgroundSize: ""
webkitBorderAfter: ""
webkitBorderAfterColor: ""
webkitBorderAfterStyle: ""
webkitBorderAfterWidth: ""
webkitBorderBefore: ""
webkitBorderBeforeColor: ""
webkitBorderBeforeStyle: ""
webkitBorderBeforeWidth: ""
webkitBorderBottomLeftRadius: ""
webkitBorderBottomRightRadius: ""
webkitBorderEnd: ""
webkitBorderEndColor: ""
webkitBorderEndStyle: ""
webkitBorderEndWidth: ""
webkitBorderHorizontalSpacing: ""
webkitBorderImage: ""
webkitBorderRadius: ""
webkitBorderStart: ""
webkitBorderStartColor: ""
webkitBorderStartStyle: ""
webkitBorderStartWidth: ""
webkitBorderTopLeftRadius: ""
webkitBorderTopRightRadius: ""
webkitBorderVerticalSpacing: ""
webkitBoxAlign: ""
webkitBoxDecorationBreak: ""
webkitBoxDirection: ""
webkitBoxFlex: ""
webkitBoxOrdinalGroup: ""
webkitBoxOrient: ""
webkitBoxPack: ""
webkitBoxReflect: ""
webkitBoxShadow: ""
webkitBoxSizing: ""
webkitClipPath: ""
webkitColumnBreakAfter: ""
webkitColumnBreakBefore: ""
webkitColumnBreakInside: ""
webkitColumnCount: ""
webkitColumnGap: ""
webkitColumnRule: ""
webkitColumnRuleColor: ""
webkitColumnRuleStyle: ""
webkitColumnRuleWidth: ""
webkitColumnSpan: ""
webkitColumnWidth: ""
webkitColumns: ""
webkitFilter: ""
webkitFlex: ""
webkitFlexBasis: ""
webkitFlexDirection: ""
webkitFlexFlow: ""
webkitFlexGrow: ""
webkitFlexShrink: ""
webkitFlexWrap: ""
webkitFontFeatureSettings: ""
webkitFontSizeDelta: ""
webkitFontSmoothing: ""
webkitHighlight: ""
webkitHyphenateCharacter: ""
webkitJustifyContent: ""
webkitLineBreak: ""
webkitLineClamp: ""
webkitLocale: ""
webkitLogicalHeight: ""
webkitLogicalWidth: ""
webkitMarginAfter: ""
webkitMarginAfterCollapse: ""
webkitMarginBefore: ""
webkitMarginBeforeCollapse: ""
webkitMarginBottomCollapse: ""
webkitMarginCollapse: ""
webkitMarginEnd: ""
webkitMarginStart: ""
webkitMarginTopCollapse: ""
webkitMask: ""
webkitMaskBoxImage: ""
webkitMaskBoxImageOutset: ""
webkitMaskBoxImageRepeat: ""
webkitMaskBoxImageSlice: ""
webkitMaskBoxImageSource: ""
webkitMaskBoxImageWidth: ""
webkitMaskClip: ""
webkitMaskComposite: ""
webkitMaskImage: ""
webkitMaskOrigin: ""
webkitMaskPosition: ""
webkitMaskPositionX: ""
webkitMaskPositionY: ""
webkitMaskRepeat: ""
webkitMaskRepeatX: ""
webkitMaskRepeatY: ""
webkitMaskSize: ""
webkitMaxLogicalHeight: ""
webkitMaxLogicalWidth: ""
webkitMinLogicalHeight: ""
webkitMinLogicalWidth: ""
webkitOpacity: ""
webkitOrder: ""
webkitPaddingAfter: ""
webkitPaddingBefore: ""
webkitPaddingEnd: ""
webkitPaddingStart: ""
webkitPerspective: ""
webkitPerspectiveOrigin: ""
webkitPerspectiveOriginX: ""
webkitPerspectiveOriginY: ""
webkitPrintColorAdjust: ""
webkitRtlOrdering: ""
webkitRubyPosition: ""
webkitShapeImageThreshold: ""
webkitShapeMargin: ""
webkitShapeOutside: ""
webkitTapHighlightColor: ""
webkitTextCombine: ""
webkitTextDecorationsInEffect: ""
webkitTextEmphasis: ""
webkitTextEmphasisColor: ""
webkitTextEmphasisPosition: ""
webkitTextEmphasisStyle: ""
webkitTextFillColor: ""
webkitTextOrientation: ""
webkitTextSecurity: ""
webkitTextSizeAdjust: ""
webkitTextStroke: ""
webkitTextStrokeColor: ""
webkitTextStrokeWidth: ""
webkitTransform: "translateY(22.2965%)"
webkitTransformOrigin: ""
webkitTransformOriginX: ""
webkitTransformOriginY: ""
webkitTransformOriginZ: ""
webkitTransformStyle: ""
webkitTransition: ""
webkitTransitionDelay: ""
webkitTransitionDuration: ""
webkitTransitionProperty: ""
webkitTransitionTimingFunction: ""
webkitUserDrag: ""
webkitUserModify: ""
webkitUserSelect: ""
webkitWritingMode: ""
whiteSpace: ""
widows: ""
width: ""
willChange: ""
wordBreak: ""
wordSpacing: ""
wordWrap: ""
writingMode: ""
x: ""
y: ""
zIndex: ""
zoom: ""

 */


// WEBPACK FOOTER //
// ./src/assets/js-plug-in-unit/config.js